<ng-template #orderView let-modal>
	<div class="modal-header">
		<div class="modal-title row m-0 p-0" id="modal-title">
			<h4>Order# {{orderdetails.header.orderno}}</h4>
		</div>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<div class="mb-3" *ngIf="orderdetails">
			<div class="row border-bottom">
				<div class="col-md-3 text-center">
					<h5>Ship Via: {{ orderdetails.header.shippername }}</h5>
				</div>
				<div class="col-md-3 text-center">
					<h5>Date Wanted: {{ orderdetails.header.datewanted }}</h5>
				</div>
				<div class="col-md-3 text-center">
					<h5>Entered By: {{ orderdetails.header.enteredby }}</h5>
				</div>
				<div class="col-md-3 text-center">
					<h5>Created: {{ orderdetails.header.date_created }}</h5>
				</div>
			</div>
			<div class="row mt-2 mb-2 border-bottom">
				<div class="col-md-3 ">
					<h5 class="mb-0">Ship To:</h5>
					<span [innerHTML]="orderdetails.header.shipto"></span>
				</div>
				<div class="col-md-3">
					<h5 class="mb-0">Phone:</h5>
					{{orderdetails.header.contactphone}}
					<ng-container *ngIf="orderdetails.header.contactemail && orderdetails.header.contactemail != ''">
						<h5 class="mb-0">Email:</h5>
						{{orderdetails.header.contactemail}}
					</ng-container>
				</div>
				<div class="col-md-3">
					<h5>Notes:</h5>
					{{orderdetails.header.comments}}
				</div>
				<div class="col-md-3">
					<h5>History: </h5>
					<ng-container *ngIf="orderdetails.dispatch_details.dispatch_id">
						<ul>
							<li *ngIf="orderdetails.dispatch_details.truck_name">ShipVia: {{ orderdetails.dispatch_details.truck_name }}</li>
							<li *ngIf="orderdetails.dispatch_details.datecreated !='0000-00-00 00:00:00'">Dispatched:
								{{ orderdetails.dispatch_details.datecreated | date:'shortDate' }}
								{{ orderdetails.dispatch_details.datecreated | date:'shortTime' }}

							</li>
							<li *ngIf="orderdetails.dispatch_details.delivery_date !='0000-00-00 00:00:00'">Delivered:
								{{ orderdetails.dispatch_details.delivery_date | date:'shortDate' }}
								{{ orderdetails.dispatch_details.delivery_date | date:'shortTime' }}
							</li>
						</ul>
					</ng-container>
					<ng-container *ngIf="!orderdetails.dispatch_details.dispatch_id">
						N/A
					</ng-container>
				</div>
			</div>
			<div class="table">
				<table class="table table-sm">
					<tr>
						<th>ITEM</th>
						<th>DESC</th>
						<th class="text-center">ORDERED</th>
						<th class="text-center">INVOICED</th>
						<th class="text-center">OUTSTANDING</th>
						<th class="text-right">PRICE</th>
						<th class="text-right">DISCOUNT</th>
						<th class="text-right">TOTAL</th>
					</tr>
					<tr *ngFor="let item of orderdetails.details">

						<td>{{item.stkcode}}</td>
						<td>{{item.description}}</td>
						<td class="text-center">{{item.ordered}}</td>
						<td class="text-center">{{item.qtyinvoiced}}</td>
						<td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
						<td class="text-right">{{item.unitprice | currency}}</td>
						<td class="text-right">{{item.discountpercent | percent }}</td>
						<td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
					</tr>
					<tr *ngFor="let t of orderdetails.saved_totals">
						<td></td>
						<td></td>
						<td></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-center"></td>
						<td class="text-right">{{ t.title }}:</td>
						<td class="text-right">{{t.text | currency}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i>Purchase Order Inquiry
						</h4>
						<p class="card-category text-right">Search purchase orders by keywords and/or vendor</p>
					</div>
					<div class="card-body">

						<div *ngIf="searchError" class="alert alert-warning py-2 small mb-3" role="alert">{{ searchError }}</div>
						<form class="navbar-form">
							<div class="row g-2 align-items-start">
								<div class="col-md-2 col-sm-6">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Max rows</mat-label>
										<input matInput type="number" min="1" max="500" [formControl]="limitRef" (keydown.enter)="$event.preventDefault();searchOrders()">
										<mat-hint>1–500</mat-hint>
									</mat-form-field>
								</div>
								<div class="col-md-12 col-sm-12 mb-2">
									<mat-slide-toggle [formControl]="includeInactiveVendors">Include inactive vendors</mat-slide-toggle>
								</div>
								<div class="col-md-4 col-sm-12">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Vendor</mat-label>
										<mat-select [formControl]="vendorSelectRef" multiple>
											<mat-option *ngFor="let v of vendors" [value]="v.supplierid">{{ v.supplierid }} - {{ v.suppname }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-6 col-sm-12">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Keywords</mat-label>
										<span matPrefix *ngIf="orderSearch.length">
											<button mat-icon-button class="p-0" type="button" (click)="clearForm()">
												<mat-icon class="p-0">clear</mat-icon>
											</button>
										</span>
										<input matInput [formControl]="orderSearchRef" placeholder="PO, trans no, requisition, contact…" (keydown.enter)="$event.preventDefault();searchOrders()">
										<span matSuffix>
											<mat-progress-spinner
												*ngIf="loading"
												mode="indeterminate"
												diameter="16"
												color="accent"
												style="margin-right: 4px;">
											</mat-progress-spinner>
											<button mat-icon-button type="button" color="white" (click)="searchOrders()">
												<mat-icon class="p-0">search</mat-icon>
											</button>
										</span>
									</mat-form-field>
								</div>
							</div>
						</form>
						<p *ngIf="orderResults && orderResults.length" class="small text-muted mb-2">
							Showing {{ orderResults.length }} PO(s) (max {{ lastLimit }}, ordered by date desc).
						</p>
						<div *ngIf="showNoResults()" class="alert alert-info py-3 mb-3" role="status">
							<strong>No results.</strong> Nothing matched your search—try different keywords or vendors.
						</div>
						<div class="po-inquiry-results" *ngIf="orderResults && orderResults.length">
							<div class="po-inquiry-card mb-4" *ngFor="let o of orderResults">
								<div class="table-responsive po-inquiry-summary-wrap">
									<table class="table table-sm table-bordered mb-0 po-summary-table">
										<thead>
											<tr>
												<th scope="col">Order#</th>
												<th scope="col">Created</th>
												<th scope="col">Vendor#</th>
												<th scope="col">Vendor name</th>
												<th scope="col">Contact</th>
												<th scope="col">Delivery</th>
												<th scope="col">Status</th>
												<th scope="col">Entered by</th>
												<th scope="col" class="po-comments-th">Status / notes</th>
												<th scope="col" class="text-end">PO total</th>
												<th scope="col" class="text-end">Net total</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="text-nowrap">{{ o.orderno }}</td>
												<td class="text-nowrap">{{ o.orddate | date: 'shortDate' }}</td>
												<td>
													<a class="link" href="javascript:void(0)" (click)="viewVendor(o.supplierno)">{{ o.supplierno }}</a>
												</td>
												<td>{{ o.suppname || '—' }}</td>
												<td class="small">{{ o.contact || '—' }}</td>
												<td class="text-nowrap">{{ o.deliverydate | date: 'shortDate' }}</td>
												<td class="status-{{ o.status_id }} text-nowrap">{{ o.status }}</td>
												<td class="small">{{ o.initiator }}</td>
												<td class="po-comments-td">
													<div class="po-comments-scroll" [innerHTML]="o.stat_comment"></div>
												</td>
												<td class="text-end text-nowrap">{{ getPoTotal(o) | currency }}</td>
												<td class="text-end text-nowrap">{{ getNetTotal(o) | currency }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="table-responsive po-inquiry-lines-wrap">
									<table class="table table-sm table-striped mb-0 po-line-table">
										<thead>
											<tr>
												<th scope="col">Item</th>
												<th scope="col">Description</th>
												<th scope="col" class="text-end">Price</th>
												<th *ngIf="config.env.package === 'tires'" scope="col" class="text-end">FET</th>
												<th *ngIf="config.env.package === 'tires'" scope="col" class="text-end">FET ext.</th>
												<th scope="col" class="text-end">Ordered <span class="text-muted small">({{ getOrderedSum(o) }})</span></th>
												<th scope="col" class="text-end">Invoiced <span class="text-muted small">({{ getReceivedSum(o) }})</span></th>
												<th scope="col" class="text-end">Net</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let det of o.details" class="poline">
												<td class="text-nowrap po-item-code">{{ det.itemcode }}</td>
												<td>{{ det.itemdescription }}</td>
												<td class="text-end text-nowrap">{{ det.unitprice | currency }}</td>
												<td *ngIf="config.env.package == 'tires'" class="text-end text-nowrap">{{ det.fetcharge | currency }}</td>
												<td *ngIf="config.env.package == 'tires'" class="text-end text-nowrap">{{ det.fetcharge * det.quantityord | currency }}</td>
												<td class="text-end">{{ det.quantityord }}</td>
												<td class="text-end">{{ det.quantityrecd }}</td>
												<td *ngIf="config.env.package != 'tires'" class="text-end text-nowrap">{{ det.quantityrecd * det.unitprice | currency }}</td>
												<td *ngIf="config.env.package == 'tires'" class="text-end text-nowrap">{{ lineNet(det) | currency }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>